define([
	"dojo/_base/declare",
	"csi/constants",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/heading/Spec",
], function(declare, constants, ExtendedPath, Key, Spec) {

	return declare(null, {
		/**
		 * Create the spec for the column or sub-column. classParams should be html.CSS_NOT_APPLICABLE if the N/A background
		 * needs to be applied and an empty string otherwise.
		 * @param {Context} ctx
		 * @param {string} targetType
		 * @param {string} path - path to the target node
		 * @param {string} attributeID - attribute id where the keys are stored on the target node
		 * @param {string} sysID
		 * @param {string} id
		 * @param {string} format
		 * @param {string} columnUrl
		 * @param {string} columnName
		 * @param {string} classParams
		 */
		createSpec(
			ctx,
			targetType,
			path,
			attributeID,
			sysID,
			id,
			format,
			columnUrl,
			columnName,
			classParams
		) {
			const {pathHints} = ctx.view.getMainQueryLevel();
			const extendedPath = ExtendedPath.create(targetType, path, pathHints);
			extendedPath.addRelationStep(attributeID, null, sysID);

			const name = id + (format || "");

			const key = new Key({
				extendedPath,
				id,
				name,
			});

			const heading = ctx.view.getHeading(key);
			heading.bCopy = true;

			const spec = new Spec({
				css: constants.CSS_TABLE_COLUMNS,
				columnUrl,
				headerParams: {
					multiLineText: columnName,
				},
				valueParams: {
					className: classParams,
				},
				heading,
			});

			// set query path to include index to specific data sheet item
			const querySpec = this._getColumnQuerySpec(ctx, spec);
			spec.setQuerySpec(querySpec);

			return spec;
		},
	})
});
